<template>
  <div class="container-appfooter">
    <wrap-container class="w100">
      <footer>
        <p v-safe-html="footerText"></p>
      </footer>
    </wrap-container>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";

export default {
  name: "AppFooter",
  components: { WrapContainer },
  data() {
    return {
      tna1mm: this.$store.getters.getTna1MM(),
      comTasaBCRA: 7922
    };
  },
  props: {
    text: String
  },
  computed: {
    footerText() {
      return this.text;
    }
  },
  mounted() {
    this.$store.watch(
      this.$store.getters.getTna1MM,
      tna1mm => {
        this.tna1mm = tna1mm;
      },
      { immediate: true }
    );
  }
};
</script>

<style scoped>
div.container-appfooter {
  background: #043263;
  color: #e4e4e4;
  font-size: 12px;
  line-height: 1.5em;
  padding: 17px;
  text-align: justify;
  margin-bottom: 0px;
  margin-left: -17px;
  margin-right: -17px;
}

img {
  display: block;
  width: 112px;
  height: auto;
  margin-top: 16px;
}

.container-appfooter >>> .footer-warning {
  font-size: 1.1em;
  line-height: 1.2em;
}
</style>
